// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"1a2bbbe6","638":"e12a2979","690":"c9f396e7","696":"04d01d4b","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};